import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';

import { FormularioOrtodontia } from '../../base/vo/formulario-ortodontia';
import { FormValidator } from '../../base/util/form-validator';
import { FaseTratamentoEnum } from '../../base/enum/fase-tratamento';

interface Fase {
	preventiva: string,
	interceptativa: string,
	corretiva: string,
	ortopedica: string
}

interface Classe {
	classe1: string,
	classe2: string,
	classe3: string
}

interface CaninoMolar {
	esquerda: Classe,
	direita: Classe
}

const FASE_INICIAL: Fase = { preventiva: 'btn', interceptativa: 'btn', corretiva: 'btn', ortopedica: 'btn'};
const CLASSE_MOLAR_INICIAL : CaninoMolar = { 
                                esquerda: { classe1: 'btn molar-classe1-default', classe2: 'btn molar-classe2-default', classe3: 'btn molar-classe3-default' } , 
                                direita: { classe1: 'btn molar-classe1-default', classe2: 'btn molar-classe2-default', classe3: 'btn molar-classe3-default' }
                            };
const CLASSE_CANINOS_INICIAL : CaninoMolar = { 
                                esquerda: { classe1: 'btn canino-classe1-default', classe2: 'btn canino-classe2-default', classe3: 'btn canino-classe3-default' } , 
                                direita: { classe1: 'btn canino-classe1-default', classe2: 'btn canino-classe2-default', classe3: 'btn canino-classe3-default' }
                            };                        

@Component({
    selector: 'app-primeira-ortodontia-passo-1',
    templateUrl: './primeira-ortodontia-passo-1.component.html',
    styleUrls: ['./primeira-ortodontia-passo-1.component.css']
})
export class PrimeiraOrtodontiaPasso1Component implements OnInit {

    @Input() formularioOrtodontia: FormularioOrtodontia;
    @Output() passoUmEvent = new EventEmitter();

    private camposObrigatorios = { 
        possuiAparelho: false, fase: false, classificacaoMolarEsquerda: false, 
        classificacaoMolarDireita: false, classificacaoCaninosEsquerda: false, classificacaoCaninosDireita: false
    };

    private camposObrigatoriasAparelho = { possuiAparelho: false, estetico: false };
    public aparelhoNao: string = 'btn';
    public aparelhoSim: string = 'btn';
    public usaAparelho: boolean = false;

    public esteticoSim: string = 'btn';
    public esteticoNao: string = 'btn';

    public fase: Fase = this.criarCopiaObjeto(FASE_INICIAL);
    
    public classificacaoMolar: CaninoMolar =  { 
        esquerda: this.criarCopiaObjeto(CLASSE_MOLAR_INICIAL.esquerda),
        direita: this.criarCopiaObjeto(CLASSE_MOLAR_INICIAL.direita)
    };

    public classificacaoCaninos: CaninoMolar = { 
        esquerda: this.criarCopiaObjeto(CLASSE_CANINOS_INICIAL.esquerda), 
        direita: this.criarCopiaObjeto(CLASSE_CANINOS_INICIAL.direita)
    };

    constructor() { }

    ngOnInit() {
        
    }

    public proximo(){
        if(this.preencheuCampoObrigatorios()){
            this.passoUmEvent.emit();
        }
    }

    public isBtnDisabled(){
        if(this.preencheuCampoObrigatorios()){
            return false;
        }
        return true;
    }

    private preencheuCampoObrigatorios(){
        let preencheuCampos = true;
        if(this.usaAparelho){
            preencheuCampos = !!this.formularioOrtodontia.tempoAparelho && !!this.formularioOrtodontia.aparelho && 
                !Object.values(this.camposObrigatoriasAparelho).some(c => c == false);
        }
        return preencheuCampos && this.formularioOrtodontia.queixaPaciente && !Object.values(this.camposObrigatorios).some(c => c == false);
    }

    public possuiAparelho(isTrue: boolean){
        if(isTrue){
            this.aparelhoNao = 'btn';
            this.aparelhoSim = 'btn btn-primary'
            this.usaAparelho = true;
            this.camposObrigatoriasAparelho.possuiAparelho = true;
            this.formularioOrtodontia.possuiAparelho = true;
        } else {
            this.aparelhoNao = 'btn btn-primary';
            this.aparelhoSim = 'btn';
            this.usaAparelho = false;
            this.camposObrigatoriasAparelho.possuiAparelho = false;
            this.formularioOrtodontia.possuiAparelho = false;
            this.formularioOrtodontia.aparelhoFixoEstetico = undefined;
            this.esteticoNao = 'btn';
            this.esteticoSim = 'btn';
            this.formularioOrtodontia.tempoAparelho = undefined;
            this.formularioOrtodontia.aparelho = undefined;
        }
        this.camposObrigatorios.possuiAparelho = true;
    }

    public isEstetico(isTrue: boolean){
        if(isTrue){
            this.esteticoNao = 'btn';
            this.esteticoSim = 'btn btn-primary';
            this.formularioOrtodontia.aparelhoFixoEstetico = true;
        } else {
            this.esteticoNao = 'btn btn-primary';
            this.esteticoSim = 'btn';
            this.formularioOrtodontia.aparelhoFixoEstetico = false;
        }
        this.camposObrigatoriasAparelho.estetico = true;
    }

    public selecionaFase(fase: string): void {
        this.fase = this.criarCopiaObjeto(FASE_INICIAL);
        this.fase[fase] = 'btn btn-primary';
        this.camposObrigatorios.fase = true;
        this.formularioOrtodontia.faseDoTratamento = FaseTratamentoEnum[fase.toUpperCase()] ;
    }

    public selecionaClassificacaoMolar(lado: string, classe: string): void {
        this.classificacaoMolar[lado] = this.criarCopiaObjeto(CLASSE_MOLAR_INICIAL[lado]);
        this.classificacaoMolar[lado][classe] = `btn btn-primary molar-${classe}-primary`;
        if(lado === 'esquerda'){
            this.camposObrigatorios.classificacaoMolarEsquerda = true;
            this.formularioOrtodontia.classificacaoMolarEsquerdo = this.getNumeroClasse(classe);
        } else {
            this.camposObrigatorios.classificacaoMolarDireita = true;
            this.formularioOrtodontia.classificacaoMolarDireito = this.getNumeroClasse(classe);
        }
    }

    public selecionaClassificacaoCaninos(lado: string, classe: string): void {
        this.classificacaoCaninos[lado] = this.criarCopiaObjeto(CLASSE_CANINOS_INICIAL[lado]);
        this.classificacaoCaninos[lado][classe] = `btn btn-primary canino-${classe}-primary`;
        if(lado === 'esquerda'){
            this.camposObrigatorios.classificacaoCaninosEsquerda = true;
            this.formularioOrtodontia.classificacaoCaninoEsquerdo = this.getNumeroClasse(classe);
        } else {
            this.camposObrigatorios.classificacaoCaninosDireita = true;
            this.formularioOrtodontia.classificacaoCaninoDireito = this.getNumeroClasse(classe);
        }
    }

    private criarCopiaObjeto(obj: any): any {
        return Object.assign({}, obj);
    }

    private getNumeroClasse(classe: string){
        return parseInt(classe[classe.length-1]);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ortodontia/primeira-ortodontia-passo-1/primeira-ortodontia-passo-1.component.ts